import React from "react";
import Switch from "react-switch";
import { ConfirmationModal } from "../../../../customControl/ConfirmationModal";
import Select from "react-select";
import { useDispatch, useSelector } from "react-redux";
import { useState } from "react";
import { useEffect } from "react";
import { GetMenuIdFromStorage } from "../../../commonClass/Menudect";
import { useNavigate } from "react-router-dom";
import {
  getAllData,
  patchUsersData,
  postUsersData,
  verifytoken,
} from "../../../../services/ApiCallingUserServices";
import { ClearLocalStorage, GetLocalStorage } from "../../../commonClass/Session";
import { loaderActions } from "../../../../_actions/loader.actions";
import { ExportExcel } from "../../../commonClass/ExportExcel";
import { generatePDF } from "../../../commonClass/CommonValidation";
import CustomTable from "../../../../customControl/CustomTable";

const AttractionsTheme = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  //jnklsjdkjsk;dj
  const [userexport, setUserExport] = useState(true);
  const [themedata, setThemeData] = useState([]);
  //sdnjlsfsjpkcfjp;ds
  const [buttonaddeditText, setButtonAddEditText] = useState("Add");
  const [activeId, setActiveId] = useState(false);
  const [modalShow, setModalShow] = useState(false);
  const [editdisabled, setEditDisabled] = useState(true);
  const [disabled, setDisabled] = useState(false);

  const [serchdisable, setSerachDisable] = useState(false);
  const [searchvalue, setSearchValue] = useState();
  const [searchby, setSerachBy] = useState("4");
  const [clrshow, setsclshow] = useState(false);

  const user = useSelector((store) => store.userstatus.tba);
  const [useradd, setUserAdd] = useState(true);
  const [useredit, setUserEdit] = useState(true);

  const [formAttractionTheme, setFormAttractionTheme] = useState({
    AttractionThemeId: 0,
    ThemeName: "",
    IsActive: false,
    UserId: 0,
  });
  const [formError, setFormError] = useState({
    duplicate: "",
    attractiontheme: "",
  });
  let errors = {
    duplicate: "",
    attractiontheme: "",
  };

  const [attractionsThemeData, setAttractionsThemeData] = useState([]);
  const getallattractionstheme = async () => {
    const allatractionstheme = await getAllData(
      "/master/v1/getallattractiontheme"
    );
    setAttractionsThemeData((allatractionstheme.data !== null && allatractionstheme.data !== undefined) ? allatractionstheme.data : [])
    //pdf0-excel state
    setThemeData(allatractionstheme.data);
  };

  //sdnfjkdhklfjsdkfjhkisdvbfgsfdgfhfjersdnfkjdfjfnlkdsfnkjdsbfnjhsvjhuvvfjhzgvjhcf
  function PdfExport() {
    //print
    const columns = ["Attractions Theme", "Active", "Created Date"];
    var rows = [];

    for (let i = 0; i < themedata?.length; i++) {
      //makwe changes inside
      var temp = [
        themedata[i].ThemeName,
        `${themedata[i].IsActive ? "Active" : "InActive"}`,
        formatDate(themedata[i].CreatedOn),
      ];
      rows = [...rows, temp];
    }
    generatePDF(columns, rows, "AttractionsTheme", "Attractions Theme");
  }

  const ExportToExcel = () => {
    const dispalyname = ["Attractions Theme", "Active", "Created Date"];
    //make chnages here
    const fields = ["ThemeName", "IsActive", "CreatedOn"];
    ExportExcel(
      dispalyname,
      fields,
      themedata,
      "AttractionsTheme",
      "AttractionsTheme.xls"
    );
  };
  //ljhsdcfnjklsdmvcbndsjkdnmvcbkjbcfkjxzcbfvsdjhgbfjkvcfsjklhfklhclksdjflksjlfjfl

  //#region handle on change
  const handleAttractionThemeChange = (e) => {
    setFormError({ ...formError, duplicate: "", attractiontheme: "" });
    setFormAttractionTheme({
      ...formAttractionTheme,
      [e.target.name]: e.target.value,
    });
    setEditDisabled(true);
  };
  //#endregion

  //#region Active/Inactive button
  const handleisActive = (e) => {
    if (buttonaddeditText === "Add") {
      formAttractionTheme.IsActive = e;
      setActiveId(!activeId);
      setFormError({ ...formError, duplicate: "", attractiontheme: "" });
    } else {
      setModalShow(true);
    }
  };

  const handleConfirmation = (e) => {
    if (e === true) {
      formAttractionTheme.IsActive = !activeId;
      setActiveId(!activeId);
      setEditDisabled(true);
      setFormError({ ...formError, duplicate: "", attractiontheme: "" });
    }
    setModalShow(false);
  };
  //#endregion

  //#region validations
  const validateData = () => {
    let error = [];
    if (
      typeof formAttractionTheme.ThemeName === "string" &&
      formAttractionTheme.ThemeName?.trim()?.length === 0
    ) {
      errors.attractiontheme = "Kindly enter the Attractions Theme name";
      error.push("attractiontheme");
    }
    setFormError(errors);
    document.getElementById(error[0]).focus();
  };
  //#endregion

  const handleAddClick = async () => {
    let statusoftoken = await verifytoken();
    if (buttonaddeditText === "Add") {
      if (statusoftoken) {
        if (formAttractionTheme.ThemeName?.trim()?.length === 0) {
          validateData();
          return;
        } else {
          if (statusoftoken) {
            const AttractionsThemeData = await postUsersData(
              "/master/v1/insertattractiontheme",
              formAttractionTheme
            );
            if (!AttractionsThemeData.status && !AttractionsThemeData.data) {
              errors.duplicate = AttractionsThemeData.message;
              setFormError(errors);
              return;
            }
            if (AttractionsThemeData.status) {
              if (AttractionsThemeData.data > 0) {
                setitems();
                dispatch({
                  type: "ALERTING",
                  message: AttractionsThemeData.message,
                });
                clear();
              } else {
                dispatch({
                  type: "ALERTING",
                  message: AttractionsThemeData.message,
                });
                return;
              }
            } else {
              dispatch({
                type: "ALERTING",
                message: AttractionsThemeData.message,
              });
              return;
            }
          } else {
            ClearLocalStorage();
            dispatch({
              type: "SESSIONOUT",
              message: "Your Session Expired. Please Login Again!",
            });
          }
        }
      } else {
        ClearLocalStorage();
        dispatch({
          type: "SESSIONOUT",
          message: "Your Session Expired. Please Login Again!",
        });
      }
    } else {
      if (statusoftoken) {
        if (formAttractionTheme.ThemeName?.trim()?.length === 0) {
          validateData();
          return;
        } else {
          if (statusoftoken) {
            const AttractionsThemeData = await patchUsersData(
              "/master/v1/updateattractiontheme",
              formAttractionTheme
            );
            if (!AttractionsThemeData.status && !AttractionsThemeData.data) {
              errors.duplicate = AttractionsThemeData.message;
              setFormError(errors);
              return;
            }
            if (AttractionsThemeData.status) {
              setitems();
              dispatch({
                type: "ALERTING",
                message: AttractionsThemeData.message,
              });
              clear();
            } else {
              dispatch({
                type: "ALERTING",
                message: AttractionsThemeData.message,
              });
              return;
            }
          } else {
            ClearLocalStorage();
            dispatch({
              type: "SESSIONOUT",
              message: "Your Session Expired. Please Login Again!",
            });
          }
        }
      } else {
        ClearLocalStorage();
        dispatch({
          type: "SESSIONOUT",
          message: "Your Session Expired. Please Login Again!",
        });
      }
    }
  };

  //#region clear button
  const handleClearClick = () => {
    clear();
  };

  function clear() {
    setFormError({ ...formError, duplicate: "", attractiontheme: "" });
    setFormAttractionTheme({
      ...formAttractionTheme,
      AttractionThemeId: 0,
      ThemeName: "",
      IsActive: false,
    });
    setActiveId(false);
    getallattractionstheme();
    setButtonAddEditText("Add");
    setDisabled(false);
    setEditDisabled(true);
    setSerachDisable(false);
    setSerachBy("4");
    setSearchValue("");
    setsclshow(false);
  }
  //#endregion

  //#region search FAQs by credentials
  const serachoption = [
    {
      label: "Attractions Theme",
      value: "1",
    },
    {
      label: "Active",
      value: "2",
    },
    // {
    //     label: 'Created Date',
    //     value: '3'
    // },
    {
      label: "All",
      value: "4",
    },
  ];
  const [filteritems, setFilterItems] = useState([]);

  const handleSearchBy = (e) => {
    setSerachBy(e.value);
  };

  const setitems = async () => {
    const allattractiontheme = await getAllData(
      "/master/v1/getallattractiontheme"
    );
    setFilterItems(allattractiontheme.data);
  };

  const handleChangeSearchValue = (e) => {
    setSearchValue(e.target.value);
    setsclshow(true);
    if (e.target.value === "") {
      getallattractionstheme();
      setsclshow(false);
    }
  };

  const clearsearch = () => {
    setSearchValue("");
    setsclshow(false);
    getallattractionstheme();
  };

  const onKeyDownHandler = (e) => {
    if (e.keyCode === 13) {
      handleClickSearchValue();
    }
  };

  const handleClickSearchValue = () => {
    if (
      typeof searchvalue === "string" &&
      searchvalue?.trim()?.length !== 0 &&
      searchby > 0
    ) {
      setitems();
      var filteritem = filteritems;
      var filterdata;
      if (searchby === "1") {
        filterdata = filteritem?.filter((issec) =>
          issec.ThemeName.toLowerCase().includes(searchvalue.toLowerCase())
        );
      }
      // else if (searchby === '5') {
      //     filterdata = filteritem?.filter(issec => formatDate(issec.CreatedOn).toLowerCase().includes(searchvalue.toLowerCase()));
      // }
      else if (searchby === "2") {
        if (searchvalue.toLowerCase() === "active".toLowerCase()) {
          filterdata = filteritem?.filter((issec) => issec.IsActive === true);
        } else if (searchvalue.toLowerCase() === "inactive".toLowerCase()) {
          filterdata = filteritem?.filter((issec) => issec.IsActive === false);
        } else if ("active".toLowerCase().includes(searchvalue.toLowerCase())) {
          filterdata = filteritem?.filter(
            (issec) => issec.IsActive === true || issec.IsActive === false
          );
        } else if (
          "inactive".toLowerCase().includes(searchvalue.toLowerCase())
        ) {
          filterdata = filteritem?.filter((issec) => issec.IsActive === false);
        } else {
          filterdata = filteritem?.filter((issec) =>
            formatDate(issec.CreatedOn).toLowerCase().includes("%#$&%^")
          );
        }
      } else if (searchby === "4") {
        if (searchvalue.toLowerCase() === "active".toLowerCase()) {
          filterdata = filteritem?.filter(
            (issec) =>
              issec.ThemeName.toLowerCase().includes(
                searchvalue.toLowerCase()
              ) ||
              formatDate(issec.CreatedOn)
                .toLowerCase()
                .includes(searchvalue.toLowerCase()) ||
              issec.IsActive === true
          );
        } else if (searchvalue.toLowerCase() === "inactive".toLowerCase()) {
          filterdata = filteritem?.filter(
            (issec) =>
              issec.ThemeName.toLowerCase().includes(
                searchvalue.toLowerCase()
              ) ||
              formatDate(issec.CreatedOn)
                .toLowerCase()
                .includes(searchvalue.toLowerCase()) ||
              issec.IsActive === false
          );
        } else if ("active".toLowerCase().includes(searchvalue.toLowerCase())) {
          filterdata = filteritem?.filter(
            (issec) =>
              issec.ThemeName.toLowerCase().includes(
                searchvalue.toLowerCase()
              ) ||
              formatDate(issec.CreatedOn)
                .toLowerCase()
                .includes(searchvalue.toLowerCase()) ||
              issec.IsActive === true ||
              issec.IsActive === false
          );
        } else if (
          "inactive".toLowerCase().includes(searchvalue.toLowerCase())
        ) {
          filterdata = filteritem?.filter(
            (issec) =>
              issec.ThemeName.toLowerCase().includes(
                searchvalue.toLowerCase()
              ) ||
              formatDate(issec.CreatedOn)
                .toLowerCase()
                .includes(searchvalue.toLowerCase()) ||
              issec.IsActive === false
          );
        } else {
          filterdata = filteritem?.filter(
            (issec) =>
              issec.ThemeName.toLowerCase().includes(
                searchvalue.toLowerCase()
              ) ||
              formatDate(issec.CreatedOn)
                .toLowerCase()
                .includes(searchvalue.toLowerCase()) ||
              "active".toLowerCase().includes(searchvalue.toLowerCase()) ||
              "inactive".toLowerCase().includes(searchvalue.toLowerCase())
          );
        }
      }
      setAttractionsThemeData(filterdata);
    }
  };
  //#endregion

  const columns = [
    {
      name: "Attractions Theme",
      sortable: true,
      float: "left",
      selector: (theme) => theme.ThemeName,
    },
    {
      name: "Active",
      sortable: true,
      float: "left",
      selector: (theme) => (theme.IsActive ? "Active" : "InActive"),
    },
    {
      name: "Created Date",
      sortable: true,
      float: "left",
      selector: (theme) => new Date(theme.CreatedOn),
      format: (theme) => formatDate(theme.CreatedOn),
    },
    {
      name: "Edit",
      selector: (theme) => (
        <button
          type="button"
          className="border-0 p-0 bg-body set_disableclr"
          disabled={!useredit}
          onClick={() => handleEditMode(theme.AttractionThemeId)}
        >
          <i className="fa fa-edit"></i>{" "}
        </button>
      ),
    },
    {
      name: "View",
      selector: (theme) => (
        <i
          className="fa fa-eye"
          onClick={() => handleViewMode(theme.AttractionThemeId)}
        ></i>
      ),
    },
  ];

  //#region Date format
  function formatDate(date) {
    var d = new Date(date),
      month = "" + (d.getMonth() + 1),
      day = "" + d.getDate(),
      year = d.getFullYear();

    if (month.length < 2) month = "0" + month;
    if (day.length < 2) day = "0" + day;

    return [day, month, year].join("/");
  }
  //#endregion

  //#region Edit and View Button
  const handleEditMode = (id) => {
    setDisabled(false);
    setEditDisabled(false);
    setSerachDisable(true);
    setButtonAddEditText("Update");
    RetriveData(id);
  };

  const handleViewMode = (id) => {
    setEditDisabled(false);
    setDisabled(true);
    setSerachDisable(true);
    RetriveData(id);
  };
  //#endregion

  function RetriveData(id) {
    setFormError({ ...formError, duplicate: "", attractiontheme: "" });
    attractionsThemeData?.map((obj) => {
      if (obj.AttractionThemeId === id) {
        formAttractionTheme.ThemeName = obj.ThemeName;
        formAttractionTheme.AttractionThemeId = obj.AttractionThemeId;
        formAttractionTheme.IsActive = obj.IsActive;
        setActiveId(obj.IsActive);
      }
    });
  }

  useEffect(() => {
    dispatch(loaderActions.start());
    let token = GetLocalStorage();
    if (token && token.userName && token.token) {
      formAttractionTheme.UserId = token?.userMasterID;
      getallattractionstheme().then(() => {
        dispatch(loaderActions.end());
      });
      setitems();
    } else {
      ClearLocalStorage();
      dispatch({
        type: "SESSIONOUT",
        message: "Your Session Expired. Please Login Again!",
      });
    }
  }, []);

  useEffect(() => {
    // let MENUID = GetMenuIdFromStorage()
    // let viewrights = false;
    // user?.filter(x => x.MenuId === MENUID).map((obj) => {
    //     setUserAdd(obj.URightAdd);
    //     setUserEdit(obj.URightEdit);
    //     setUserExport(obj.URightExport);
    // });
    // if (!viewrights) {
    //     navigate('/Dashboard');
    // }

    // let MENUID = GetMenuIdFromStorage();
    // let mid = user?.find((x) => x.MenuId === MENUID);
    let pagelink = user?.find(x => {
      if (x.PageLink === window.location.pathname)
        return x.MenuId
    });
    let mid = user?.find(x => x.MenuId === pagelink.MenuId);
    if (mid?.URightView === false && mid?.URightView !== undefined) {
      navigate("/dashboard");
    }
    user
      // ?.filter((x) => x.MenuId === MENUID)
      ?.filter((x) => x.MenuId === pagelink.MenuId)
      .map((obj) => {
        setUserAdd(obj.URightAdd);
        setUserEdit(obj.URightEdit);
        //hbjkh
        setUserExport(obj.URightExport);
        //vbgjhuiu
      });
  }, [user]);

  return (
    <>
      <div className="container-fluid mt-4 heading_color">
        <h3>Attractions Theme</h3>
      </div>
      <div className="container-fluid form_border pb-5 my-3">
        <div className="row mx-1 mt-4 mb-3"></div>
        <form action="">
          <div className="row mb-3 mx-1">
            <div className="col-lg-12 col-md-12 col-sm-12">
              <div className="row">
                <div className="col-md-12">
                  <div className="row">
                    {formError.duplicate && (
                      <div className="text-center text-danger pb-3">
                        {" "}
                        {formError.duplicate}{" "}
                      </div>
                    )}
                    <div className="col-lg-3 col-md-12 col-sm-12 mb-lg-1">
                      <label
                        className="col-form-label required"
                        htmlFor="attractiontheme"
                      >
                        Attractions Theme
                      </label>
                    </div>
                    <div className="col-lg-9 col-md-12 col-sm-12 mb-lg-1">
                      <div className="col-lg-6 col-md-8">
                        <input
                          type="text"
                          className="form-control"
                          name="ThemeName"
                          id="attractiontheme"
                          value={formAttractionTheme.ThemeName}
                          onChange={(e) => handleAttractionThemeChange(e)}
                          maxLength={100}
                          disabled={disabled ? true : false}
                          placeholder="Attractions Theme"
                        />
                        {formError.attractiontheme && (
                          <div className="text-start text-danger">
                            {formError.attractiontheme}
                          </div>
                        )}
                      </div>
                    </div>

                    <div className="col-lg-3 col-md-12 col-sm-12">
                      <label htmlFor="active" className="col-form-label">
                        Active
                      </label>
                    </div>
                    <div className="col-auto col-lg-6 " disabled={false}>
                      <Switch
                        id="active"
                        onChange={handleisActive}
                        checked={activeId}
                        className="react-switch"
                        disabled={disabled ? true : false}
                      />
                    </div>
                    <ConfirmationModal
                      show={modalShow}
                      onHide={() => setModalShow(false)}
                      noconfirm={() => handleConfirmation(false)}
                      yesconfirm={() => handleConfirmation(true)}
                    />
                  </div>
                </div>
              </div>

              <div className="d-flex justify-content-center mb-4">
                {useradd === false && buttonaddeditText === "Add" ? (
                  <button
                    type="button"
                    class="btn btn-primary mx-1"
                    id="btnAdd"
                    onClick={handleAddClick}
                    disabled={!useradd}
                  >
                    {buttonaddeditText}
                  </button>
                ) : (
                  <button
                    type="button"
                    className="btn btn-primary mx-1"
                    id="btnAdd"
                    onClick={handleAddClick}
                    disabled={editdisabled ? false : true}
                  >
                    {buttonaddeditText}
                  </button>
                )}
                <button
                  type="button"
                  className="btn btn-primary mx-1"
                  id="btnClear"
                  onClick={handleClearClick}
                >
                  Clear
                </button>
              </div>

              <div className="row">
                <div className="d-lg-flex d-md-flex d-sm-block justify-content-end px-0">
                  <div className="p-2 col-lg-2 col-md-4 col-sm-12">
                    <Select
                      className="dropdown select_dropdown"
                      options={serachoption}
                      value={serachoption?.filter(function (serachoption) {
                        return serachoption.value === searchby;
                      })} // set list of the datavalue
                      onChange={handleSearchBy} // assign onChange function
                      isDisabled={serchdisable ? true : false}
                      isSearchable={false}
                    />
                  </div>
                  <div className="p-2 col-lg-2 col-md-4 col-sm-12">
                    <div className="clrbutton">
                      <input
                        type="text"
                        onKeyDown={onKeyDownHandler}
                        id="btnSearchText"
                        className="form-control"
                        placeholder="Enter keyword"
                        name="SearchValue"
                        onChange={handleChangeSearchValue}
                        value={searchvalue}
                        disabled={serchdisable ? true : false}
                      />
                      <button
                        className={`${clrshow === true ? "d-block" : "d-none"}`}
                        disabled={serchdisable ? true : false}
                        onClick={clearsearch}
                        type="reset"
                      >
                        &times;
                      </button>
                    </div>
                  </div>
                  <div className="p-2 text-center">
                    <button
                      type="button"
                      className="btn btn-primary mx-1"
                      id="btnSearch"
                      disabled={serchdisable ? true : false}
                      onClick={handleClickSearchValue}
                    >
                      Search
                    </button>
                  </div>
                </div>
              </div>
              <CustomTable
                columns={columns}
                data={attractionsThemeData}
                PdfExport={PdfExport}
                ExportToExcel={ExportToExcel}
                disabled={!userexport}
              />
            </div>
          </div>
        </form>
      </div>
    </>
  );
};

export default AttractionsTheme;
